import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { Checklist as ChecklistIcon, Tune as TuneIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

const ReleaseCheckNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const isManage = location.pathname.endsWith('/manage')

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        top: 0,
        mb: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<ChecklistIcon />}
            onClick={() => navigate('/release-check')}
            sx={{ ml: 2, fontWeight: isManage ? 400 : 700 }}
          >
            {t('releaseCheck.title', 'Release Checklist')}
          </Button>
          <Button
            color="inherit"
            startIcon={<TuneIcon />}
            onClick={() => navigate('/release-check/manage')}
            sx={{ ml: 1, fontWeight: isManage ? 700 : 400 }}
          >
            {t('releaseCheck.manage.title', 'Manage items')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default ReleaseCheckNav
